import { render, staticRenderFns } from "./SrFilter.vue?vue&type=template&id=2f71ed13"
import script from "./SrFilter.vue?vue&type=script&lang=js"
export * from "./SrFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports